// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eventId: __t.u64().primaryKey().name("event_id"),
  versonaId: __t.u64().name("versona_id"),
  identity: __t.identity(),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  label: __t.string(),
  weight: __t.i32(),
  halfLifeS: __t.u32().name("half_life_s"),
  at: __t.timestamp(),
});
